<div class="form-group">
  @if (label) {
    <label class="fw-bold">{{ label }}</label>
  }
  <div class="input-group shadow-sm">
    <input
      [type]="type"
      [formControl]="inputFormControl"
      class="form-control"
      [ngClass]="{
        'is-invalid': inputFormControl && inputFormControl.invalid && (inputFormControl.touched || inputFormControl.dirty),
        'is-valid': inputFormControl && inputFormControl.valid && (inputFormControl.touched || inputFormControl.dirty),
        'warning-field': showWarning
      }"
      [readonly]="readonly"
      [placeholder]="placeholder"
      autocomplete="new-password"
      />
    @if (suffix !== '') {
      <span class="input-group-text">{{suffix}}</span>
    }
  </div>
  @if (inputFormControl && inputFormControl.invalid && (inputFormControl.touched || inputFormControl.dirty)) {
    <div class="text-danger small">
      @if (inputFormControl.errors?.['required']) {
        <span><i class="fa fa-exclamation-circle me-1"></i>Required field</span>
      }
      @if (inputFormControl.errors?.['minlength']) {
        <span><i class="fa fa-exclamation-circle me-1"></i>At least 3 characters required.</span>
      }
      @if (inputFormControl.errors?.['email']) {
        <span><i class="fa fa-exclamation-circle me-1"></i>Enter a valid email address.</span>
      }
      @if (inputFormControl.errors?.['invalidEmail']) {
        <span><i class="fa fa-exclamation-circle me-1"></i>Invalid email. Please enter a correct email address.</span>
      }
    </div>
  }

  @if (inputFormControl && inputFormControl.invalid && (inputFormControl.touched || inputFormControl.dirty)) {
    <div class="text-danger small">
      @if (inputFormControl.errors?.['passwordStrength']) {
        <span>
          <i class="fa fa-exclamation-circle me-1"></i>The password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.
        </span>
      }
      @if (inputFormControl.errors?.['passwordMismatch']) {
        <span>
          <i class="fa fa-exclamation-circle me-1"></i>Passwords do not match.
        </span>
      }
      @if (inputFormControl.errors?.['pattern']) {
        <span>
          <i class="fa fa-exclamation-circle me-1"></i>The password must be at least 8 characters long and include 1 uppercase letter, 1 lowercase letter, and 1 special character.
        </span>
      }
      @if (inputFormControl.errors?.['backendError']) {
        <span>
          <i class="fa fa-exclamation-circle me-1"></i>{{ inputFormControl.errors?.['backendError'] }}
        </span>
      }
    </div>
  }
</div>